import RoutesMap from '../../route_control/RouteControl.js'
import {
    QuestionList,
    AddQuestion,
    UpdateQuestion,
    QuestionBankList,
    AddQuestionBank,
    UpdateQuestionBank,
    QuestionBankDetails,
    ExamList,
    AddExam,
    UpdateExam,
    ExamDetails,
    ExamQuestionList,
    AddExamQuestion,
    TestDesignerList,
    AddTestDesigner,
    UpdateTestDesigner,
    TestDesignerDetails,
    ExamInvitationList,
    AddExamInvitation
} from "../../pages/paper_generation"

export const PaperGenerationImport = {
    RoutesMap,
    QuestionList,
    AddQuestion,
    UpdateQuestion,
    QuestionBankList,
    AddQuestionBank,
    UpdateQuestionBank,
    QuestionBankDetails,
    ExamList,
    AddExam,
    UpdateExam,
    ExamDetails,
    ExamQuestionList,
    AddExamQuestion,
    TestDesignerList,
    AddTestDesigner,
    UpdateTestDesigner,
    TestDesignerDetails,
    ExamInvitationList,
    AddExamInvitation
}

export default PaperGenerationImport;
